import { Component } from '@angular/core';

@Component({
  selector: 'app-popcorn-after-page',
  templateUrl: './popcorn-after-page.component.html',
  styleUrls: ['./popcorn-after-page.component.scss'],
})
export class PopcornAfterPageComponent {}
